import React from 'react';
import '../../scss/components/FileInput.scss';

interface FileProps {
    onChange?:any,
    name:string,
    className?:string,
    wrapperClassName?:string,
    error?:string,
    accept?:string,
    label?:string,
    required?:boolean
};

const FileInput = ({
    onChange,
    name,
    className,
    wrapperClassName,
    error,
    accept,
    label,
    required = false
}:FileProps) => {
    return (
        <>
            <div className={`form-group file-input${wrapperClassName ? ' ' + wrapperClassName : ''}`}>
                <label className='file-input-label' htmlFor={name}>{label} {required ? '*' : ''}</label>
                <span className='file-icon'></span>
                <input
                    accept={accept}
                    type="file"
                    name={name}
                    id={name}
                    onChange={onChange}
                    className={(className ? className : '') + (error ? ' invalid' : '')}
                    title=''
                />
            </div>        
            { error && (
                <span className='form-error' role='alert'>{ error }<br></br></span>
            ) }
        </>
    )
}

export default FileInput;